import { z } from 'zod';
// Персональные UI-настройки пользователя. key — строковый идентификатор
// (например 'viewstate:{spaceId}:filters' или 'table:{spaceId}:{viewId}'),
// value — произвольный JSON-payload этой настройки.
// Ограничение на длину ключа, чтобы не плодить мусор и не пухла таблица.
export const PreferenceKeySchema = z.string().min(1).max(200);
// value — любой JSON; на уровне контракта не типизируем, т.к. payload зависит
// от конкретной настройки (фильтры, сортировки, настройки таблицы и т.д.).
export const PreferenceValueSchema = z.unknown();
export const PreferencesMapResponseSchema = z.object({
    preferences: z.record(z.unknown()),
});
export const SetPreferenceRequestSchema = z.object({
    value: PreferenceValueSchema,
});
